import React from 'react';
import styled from 'styled-components';
import RequestAppointmentFormHero from '../appointment/OnlineAppointment2';
import DocImage from '../../assets/raj/raj.webp';
import OpdForm from '../OpdForm';



const profileHighlights = [
  '20+ years of clinical experience',
  'Advanced specialization in Cardiology, Diabetology & Endocrinology',
  'Managing complex chronic diseases & patient-centered care',
];

const qualifications = [
  'MBBS (CAL), MD, IHC, FCCM',
  'CDM, King George Medical University (Lucknow)',
  
  'PG Diploma Nephrology (Royal College of Physicians, UK)',
  'PG Diploma in Diabetes and Renal Management (Royal College of Physicians)',
  'PG Diploma in Clinical Endocrinology and Diabetes (Royal College of Physicians)',
  'Certificate Course in Obesity Prevention and Management (CCOPM)',
  'CCMH (Public Health Foundation of India)',
 'BLS and ACLS expert from American Heart Association (AHA)',
  'Certified Nephrologist (Apollo Hospital, Delhi)',
  'Certificate Course in Evidence Based Diabetes Management (PHFI)',
  'Certificate in Cardio Vascular Disease (PHFI, RCP)',
  'Certificate Course in Cardiovascular Disease & Stroke (RCP, London)',
  'Certificate Course in Hypertension and Cardiovascular Risk (Diabetes India & RCP, UK)',
  'Diabeto Smart Certification (Joslin Diabetes Center, USA)',
  'Certificate Course in Comprehensive assess in Respiratory Education (CHEST)',
  'Certification Course in Management of Fungal Infection (AACME)',
  'Certificate in Current Concepts for Leadership in Diabetes Management (ADA)',
  'Post Graduate Course in Advanced Diabetes Management (Learna, UK Accredited)',
  'Advanced Treatment and Effective Management of Diabetes and Hypoglycemia (Endocrine Society, USA)',
  'Certificate Course on MasterClass in Diabetes Complications (EACME)',
];

const experience = [
  'Director & Senior Consultant Physician – Cardiology, Diabetology at Isha Health Care, Patna',
  'Ex-Resident Nephrology, Apollo Hospital (Delhi)',
  'Rotated through Cardiology, ICU, and Endocrinology departments',
  'Expertise in managing emergencies such as DKA, hypertensive crises, and arrhythmias',
  'Presented clinical cases and research in academic conferences',
];

const complications = [
  'Heart and blood vessel disease',
  'Diabetic retinopathy',
  'Neuropathy and nerve damage',
  'Kidney damage and diabetic nephropathy',
  'Hormonal imbalance',
  'Skin infection and delayed wound healing',
];

const philosophyPoints = [
  "Personalized treatment plans based on each patient's condition and history",
  'Preventive care with early intervention and regular monitoring',
  'Clear patient education for long-term disease control',
  'Lifestyle, diet, and medication management under one treatment plan',
];

const whyChoosePoints = [
  'Experienced physician and diabetologist in Patna with 20+ years of clinical experience',
  'Advanced endocrinology and diabetes training with UK and USA certifications',
  'Strong track record in treating chronic and lifestyle diseases including cardiac and metabolic disorders',
  'Trusted for accurate diagnosis and practical long-term care',
  'Expertise in ECG, ECHO, TMT, Holter Monitoring, and CGM interpretation',
  'Visiting Faculty at NINI (Govt. of India) & DG-Shipping Approved Medical Examiner',
];

const stats = [
  { value: '77M+', label: 'People in India living with diabetes', highlight: true },
  { value: '50%', label: 'Cases estimated to remain undiagnosed', highlight: true },
  { value: '2-4x', label: 'Higher heart disease risk when diabetes is poorly managed', highlight: true },
];

const awards = [
  'Certificate of Honour – Expert Knowledge',
  'Lions Club of Pune Spectrum & Wallace Foundation Recognition',
  'Novel Coronavirus Warrior Recognition',
  'Bihar Ratna Samman - 2021',
  'Vaishali Gaurav Samman - 2022',
  "Bihar Doctor's Icon Award  - 2023 "
];

const memberships = [
  'Ex-CMO, Gov. of Bihar',
  'Member, Global Association of Physicians of India Origin',
  'Visiting Faculty, NINI (Govt. of India)',
  'DG- Shipping Approved Medical Examiner (Govt. of India)',
  'American Association of Continuing Medical Education',
  'Endocrine Society (USA)',
  'Chest Research Foundation',
  'Joslin Diabetes Center',
];

const medicalRegistrations = [
  '34726/07 (Delhi)',
  '62930/07 (Calcutta)',
  '39133/10 (Bihar)',
];

const areasOfExpertise = [
  'Diabetes Mellitus (Type 1 & 2), Insulin Therapy',
  'Kidney Disorder',
  'Obesity',
  'Preventive Cardiology & Lifestyle Modification',
  'Hypertension & Heart Disease Management',
  'Thyroid & Metabolic Disorders',
  'Lipid Disorders, PCOS',
  'ECG, ECHO, TMT, Holter Monitoring',
  'Hormonal Disorders (Pituitary, Adrenal, Reproductive)',
  'Patient Counseling & Chronic Care Planning',
];

const practiceLocations = [
  { 
    name: 'Isha Health Care', 
    address: 'Bajrangpuri, Gaighat, Patna-7', 
    fullAddress: 'Bajrangpuri, Gaighat, Patna, Bihar - 800007',
    phones: ['9835455222', '9308885006'],
    lat: 25.5941,
    lng: 85.1376,
    mapUrl: 'https://maps.google.com/?q=Bajrangpuri+Gaighat+Patna+Bihar'
  },
  { 
    name: 'Shree Krishna Chikitsa Kendra', 
    address: 'Gandhi Chowk, Mehendru, Patna-6',
    fullAddress: 'Gandhi Chowk, Mehendru, Patna, Bihar - 800006',
    phones: ['9700004415'],
    lat: 25.6010,
    lng: 85.1400,
    mapUrl: 'https://maps.google.com/?q=Gandhi+Chowk+Mehendru+Patna+Bihar'
  },
  /* { 
    name: 'Shree Health Care', 
    address: 'SDO Road, Hajipur-844101',
    fullAddress: 'SDO Road, Hajipur, Vaishali, Bihar - 844101',
    phones: ['8553990000'],
    lat: 25.6850,
    lng: 85.2150,
    mapUrl: 'https://maps.google.com/?q=SDO+Road+Hajipur+Bihar'
  }, */
];

const DoctorProfile = () => {
  const openGoogleMaps = (location) => {
    window.open(location.mapUrl, '_blank');
  };

  return (
    <PageSection>
      <Container>
        <HeroPanel>
          <ProfileVisual>
            <ImageFrame>
              <DoctorImage src={DocImage} alt="Dr. Raj Kamal" />
            </ImageFrame>
            {/* <ImageCaption>
              <HighlightText>
                <strong>🏥 Medical Council Registrations:</strong><br />
                {medicalRegistrations.join(' | ')}
              </HighlightText>
            </ImageCaption> */}
          </ProfileVisual>

          <HeroContent>
            <Eyebrow>⭐ Top Rated Doctor in Patna</Eyebrow>
            <Name>Dr. Raj Kamal</Name>
            <Title>Consultant Physician & Diabetologist</Title>
            
            <Lead>
              Dedicated and compassionate physician with <HighlightText>20+ years of clinical experience</HighlightText> in Internal Medicine, 
              with advanced specialization in <HighlightText> Diabetology, Obesity,  and Endocrinology</HighlightText>.
            </Lead>

            <BadgeRow>
              {profileHighlights.map((item) => (
                <Badge key={item}>{item}</Badge>
              ))}
            </BadgeRow>

            <IntroCard>
              <SectionText>
                Recognized for strong clinical acumen, leadership in multidisciplinary teams, and commitment 
                to preventive healthcare and patient education. Extensively trained and certified with 
                <HighlightText> numerous certifications from Royal College of Physicians (UK), Endocrine Society (USA), 
                and Joslin Diabetes Center.</HighlightText>
              </SectionText>
            </IntroCard>
          </HeroContent>
        </HeroPanel>

        <ContentGrid>
          <MainColumn>
            <SectionCard gradient="blue">
              <CardIcon>🎓</CardIcon>
              <SectionHeading>Qualifications and Medical Expertise</SectionHeading>
              <SectionText>
                Dr. Raj Kamal holds advanced qualifications from prestigious institutions including 
                <HighlightText> Royal College of Physicians (UK), King George Medical University, 
                and Public Health Foundation of India.</HighlightText>
              </SectionText>
              <QualificationGrid>
                {qualifications.map((item) => (
                  <QualificationItem key={item}>
                    <QualificationIcon>✅</QualificationIcon>
                    {item}
                  </QualificationItem>
                ))}
              </QualificationGrid>
              {/* <ReadMoreLink href="#">View all 20+ qualifications →</ReadMoreLink> */}
            </SectionCard>

            <SectionCard gradient="green">
              <CardIcon>💼</CardIcon>
              <SectionHeading>Professional Experience</SectionHeading>
              <Timeline>
                {experience.map((item, idx) => (
                  <TimelineItem key={item}>
                    <TimelineDot />
                    <TimelineContent>
                      <TimelineText>{item}</TimelineText>
                    </TimelineContent>
                  </TimelineItem>
                ))}
              </Timeline>
            </SectionCard>

            <SectionCard gradient="orange">
              <CardIcon>⚕️</CardIcon>
              <SectionHeading>Areas of Expertise</SectionHeading>
              <ExpertiseGrid>
                {areasOfExpertise.map((item) => (
                  <ExpertiseBadge key={item}>{item}</ExpertiseBadge>
                ))}
              </ExpertiseGrid>
            </SectionCard>

            <FeatureSection>
              <SectionHeaderBlock>
                <SectionHeading>📊 Diabetes Care with a Preventive Approach</SectionHeading>
                <SectionText>
                  Diabetes requires continuous monitoring and a treatment plan that reduces long-term risk.
                </SectionText>
              </SectionHeaderBlock>

              <StatsGrid>
                {stats.map((item) => (
                  <StatCard key={item.label} highlight={item.highlight}>
                    <StatValue>{item.value}</StatValue>
                    <StatLabel>{item.label}</StatLabel>
                  </StatCard>
                ))}
              </StatsGrid>

              <InfoAlert>
                💡 <strong>Did You Know?</strong> Dr. Raj Kamal focuses on early detection, lifestyle correction, 
                medication planning, and regular follow-up to reduce avoidable complications.
              </InfoAlert>
            </FeatureSection>

            <TwoUpGrid>
              <SectionCard gradient="purple">
                <CardIcon>⚠️</CardIcon>
                <SectionHeading>Prevention of Complications</SectionHeading>
                <SectionText>Poorly managed diabetes can increase the risk of:</SectionText>
                <WarningList>
                  {complications.map((item) => (
                    <WarningItem key={item}>
                      <WarningIcon>🔴</WarningIcon>
                      {item}
                    </WarningItem>
                  ))}
                </WarningList>
              </SectionCard>

              <QuoteCard>
                <CardIcon>💭</CardIcon>
                <SectionHeading style={{color:`#fff`}}>Treatment Philosophy</SectionHeading>
                <List>
                  {philosophyPoints.map((item) => (
                    <ListItem key={item}>{item}</ListItem>
                  ))}
                </List>
                <Quote>
                  "Treat today, so complications do not arise tomorrow."
                </Quote>
              </QuoteCard>
            </TwoUpGrid>

            <SectionCard gradient="teal">
              <CardIcon>🏆</CardIcon>
              <SectionHeading>Awards & Recognitions</SectionHeading>
              <AwardGrid>
                {awards.map((item) => (
                  <AwardItem key={item}>
                    <AwardIcon>🌟</AwardIcon>
                    {item}
                  </AwardItem>
                ))}
              </AwardGrid>
            </SectionCard>

            <SectionCard gradient="indigo">
              <CardIcon>🤝</CardIcon>
              <SectionHeading>Professional Memberships & Faculty Roles</SectionHeading>
              <MembershipGrid>
                {memberships.map((item) => (
                  <MembershipItem key={item}>
                    <MembershipIcon>👥</MembershipIcon>
                    {item}
                  </MembershipItem>
                ))}
              </MembershipGrid>
            </SectionCard>
          </MainColumn>

          <SideColumn>
            <StickyCard>
              <SectionCard gradient="red">
                <CardIcon>❤️</CardIcon>
                <SectionHeading>Why Choose Dr. Raj Kamal?</SectionHeading>
                <CheckList>
                  {whyChoosePoints.map((item) => (
                    <CheckItem key={item}>
                      <CheckIcon>✓</CheckIcon>
                      {item}
                    </CheckItem>
                  ))}
                </CheckList>
              </SectionCard>

              <LocationCard>
                <CardIcon>📍</CardIcon>
                <SectionHeading>Practice Locations</SectionHeading>
                {practiceLocations.map((location, idx) => (
                  <LocationItem key={idx}>
                    <LocationName>{location.name}</LocationName>
                    <Address>{location.address}</Address>
                    <PhoneLinks>
                      {location.phones.map(phone => (
                        <PhoneLinkSmall key={phone} href={`tel:${phone}`}>
                          📞 {phone}
                        </PhoneLinkSmall>
                      ))}
                    </PhoneLinks>
                    <MapButton onClick={() => openGoogleMaps(location)}>
                      🗺️ Get Directions on Google Maps
                    </MapButton>
                    {idx < practiceLocations.length - 1 && <Divider />}
                  </LocationItem>
                ))}
                <ResidenceInfo>
                  <HighlightText>🏠 Residence Contact:</HighlightText> 📞 <HighlightNumber>9308885006</HighlightNumber>
                </ResidenceInfo>
                <EmergencyBadge>
                  🚨 Emergency Consultation Available
                </EmergencyBadge>
                <AppointmentButton href="tel:9835455222">
                  📅 Book Emergency Appointment
                </AppointmentButton>
              </LocationCard>

              <SectionCard gradient="pink">
                <CardIcon>🔬</CardIcon>
                <SectionHeading>Research & Community Work</SectionHeading>
                <SectionText>
                  A <HighlightText>renowned speaker</HighlightText> with special interest in Diabetes & Cardiology. 
                  Academically inclined and devotes substantial time to conducting research programs. 
                  Initiated <HighlightText>numerous awareness camps</HighlightText> in Patna District and suburban areas for patient benefit.
                </SectionText>
                <CommunityBadge>
                  🏥 50+ Health Awareness Camps Organized
                </CommunityBadge>
              </SectionCard>

              <FormCard>
                <CardIcon>📋</CardIcon>
                <SectionHeading>Quick Consultation</SectionHeading>
                <FormWrapper>
                  <OpdForm/>
                </FormWrapper>
              </FormCard>
            </StickyCard>
          </SideColumn>
        </ContentGrid>
      </Container>
    </PageSection>
  );
};

export default DoctorProfile;

// Styled Components

const PageSection = styled.section`
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="rgba(255,255,255,0.1)" fill-opacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,154.7C960,171,1056,181,1152,165.3C1248,149,1344,107,1392,85.3L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>') repeat-x bottom;
    opacity: 0.1;
    pointer-events: none;
  }
`;

const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 3rem 1.5rem 4rem;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    padding: 2rem 1rem 3rem;
  }
`;

const HeroPanel = styled.section`
  display: grid;
  grid-template-columns: minmax(280px, 420px) minmax(0, 1fr);
  gap: 2rem;
  align-items: stretch;
  margin-bottom: 2rem;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`;

const ProfileVisual = styled.div`
  background: linear-gradient(160deg, #ffffff 0%, #fffff 100%);
  border-radius: 28px;
  padding: 1.25rem;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
  color: #f4fbff;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
  }
`;

const ImageFrame = styled.div`
  border-radius: 22px;
  overflow: hidden;

  background-color:#fff;
  min-height: 100%;
`;

const DoctorImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  min-height: 360px;
  object-fit: cover;

  @media (max-width: 768px) {
    min-height: 280px;
  }
`;

const ImageCaption = styled.p`
  margin-top: -3.5rem;
  font-size: 0.85rem;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.95);
  padding: 4px;
`;

const HeroContent = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 28px;
  padding: 2rem;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
  }

  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;

const Eyebrow = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.45rem 0.8rem;
  border-radius: 999px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

const Name = styled.h1`
  margin: 1rem 0 0.25rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: clamp(2rem, 4vw, 3.4rem);
  line-height: 1.05;
`;

const Title = styled.p`
  margin: 0;
  color: #1b7ca8;
  font-size: clamp(1rem, 2vw, 1.25rem);
  font-weight: 700;
  line-height: 1.5;
`;

const ContactInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin: 0.75rem 0 0;
  font-size: 0.9rem;
  padding: 0.75rem 0;
  border-top: 2px solid #667eea20;
  border-bottom: 2px solid #667eea20;
`;

const ContactItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #2d3748;
  font-weight: 500;
`;

const Lead = styled.p`
  margin: 1.25rem 0 0;
  color: #4a5568;
  font-size: 1rem;
  line-height: 1.8;
`;

const BadgeRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin: 1.5rem 0;
`;

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.65rem 0.95rem;
  border-radius: 999px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 0.9rem;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
`;

const IntroCard = styled.div`
  border-radius: 20px;
  padding: 1.1rem 1.15rem;
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  border: none;
  color: white;
  
  p {
    color: white;
  }
`;

const ContentGrid = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(320px, 0.85fr);
  gap: 2rem;
  align-items: start;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

const MainColumn = styled.div`
  display: grid;
  gap: 1.5rem;
`;

const SideColumn = styled.aside`
  display: grid;
  gap: 1.5rem;
`;

const StickyCard = styled.div`
  position: sticky;
  top: 2rem;
  display: grid;
  gap: 1.5rem;
`;

const SectionCard = styled.article`
  background: white;
  border-radius: 24px;
  padding: 1.75rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 5px;
    background: ${props => {
      switch(props.gradient) {
        case 'blue': return 'linear-gradient(90deg, #2193b0, #6dd5ed)';
        case 'green': return 'linear-gradient(90deg, #11998e, #38ef7d)';
        case 'orange': return 'linear-gradient(90deg, #f12711, #f5af19)';
        case 'purple': return 'linear-gradient(90deg, #8e2de2, #4a00e0)';
        case 'teal': return 'linear-gradient(90deg, #00b4db, #0083b0)';
        case 'indigo': return 'linear-gradient(90deg, #5f0a87, #a4508b)';
        case 'red': return 'linear-gradient(90deg, #cb2d3e, #ef473a)';
        case 'pink': return 'linear-gradient(90deg, #ff6a88, #ff99ac)';
        default: return 'linear-gradient(90deg, #667eea, #764ba2)';
      }
    }};
  }
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
  }
`;

const CardIcon = styled.div`
  font-size: 2.5rem;
  margin-bottom: 1rem;
`;

const FeatureSection = styled(SectionCard)`
  background: linear-gradient(135deg, #ffffff 0%, #dddddd 100%);
`;

const SectionHeaderBlock = styled.div`
  margin-bottom: 1.5rem;
`;

const SectionHeading = styled.h2`
  margin: 0 0 0.8rem;
  color: #2d3748;
  font-size: 1.5rem;
  line-height: 1.25;

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

const SectionText = styled.p`
  margin: 0;
  color: #4a5568;
  font-size: 0.98rem;
  line-height: 1.75;
`;

const HighlightText = styled.span`
  background: linear-gradient(120deg, #f9f047 0%, #f9f047 40%, transparent 60%);
  padding: 0 0.25rem;
  font-weight: 700;
  color: #2d3748;
`;

const HighlightNumber = styled.span`
  background: linear-gradient(135deg, #667eea, #764ba2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 800;
  font-size: 1.1em;
`;

const QualificationGrid = styled.div`
  display: grid;
  gap: 0.75rem;
  margin-top: 1rem;
`;

const QualificationItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem;
  background: #f7fafc;
  border-radius: 12px;
  transition: all 0.3s ease;
  
  &:hover {
    background: linear-gradient(135deg, #667eea10, #764ba210);
    transform: translateX(5px);
  }
`;

const QualificationIcon = styled.span`
  font-size: 1.1rem;
`;

const ReadMoreLink = styled.a`
  display: inline-block;
  margin-top: 1rem;
  color: #667eea;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
`;

const Timeline = styled.div`
  margin-top: 1rem;
`;

const TimelineItem = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  position: relative;
`;

const TimelineDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, #11998e, #38ef7d);
  margin-top: 0.5rem;
  flex-shrink: 0;
`;

const TimelineContent = styled.div`
  flex: 1;
`;

const TimelineText = styled.p`
  margin: 0;
  color: #4a5568;
  line-height: 1.6;
`;

const ExpertiseGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1rem;
`;

const ExpertiseBadge = styled.span`
  padding: 0.6rem 1.2rem;
  background: linear-gradient(135deg, #f12711, #f5af19);
  color: white;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 600;
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 5px 15px rgba(241, 39, 17, 0.3);
  }
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const StatCard = styled.div`
  border-radius: 20px;
  padding: 1.5rem;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  text-align: center;
  transition: all 0.3s ease;
  animation: pulse 2s infinite;
  
  @keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.05); }
  }
  
  &:hover {
    transform: translateY(-5px);
  }
`;

const StatValue = styled.div`
  font-size: clamp(1.8rem, 3vw, 2.5rem);
  font-weight: 800;
  line-height: 1;
`;

const StatLabel = styled.p`
  margin: 0.85rem 0 0;
  color: rgba(255, 255, 255, 0.95);
  line-height: 1.55;
  font-size: 0.85rem;
`;

const InfoAlert = styled.div`
  padding: 1rem;
  background: linear-gradient(135deg, #f9f04720, #f9f04710);
  border-left: 4px solid #f9f047;
  border-radius: 12px;
  color: #2d3748;
  font-size: 0.9rem;
  margin-top: 1rem;
`;

const TwoUpGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.5rem;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const WarningList = styled.div`
  margin-top: 1rem;
  display: grid;
  gap: 0.75rem;
`;

const WarningItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem;
  background: #fff5f5;
  border-radius: 10px;
  color: #c53030;
`;

const WarningIcon = styled.span`
  font-size: 1rem;
`;

const QuoteCard = styled(SectionCard)`
  background: linear-gradient(135deg, #A62C2C, #E83F25);
`;

const List = styled.ul`
  list-style: none;
  margin: 1rem 0 0;
  padding: 0;
  display: grid;
  gap: 0.8rem;
`;

const ListItem = styled.li`
  position: relative;
  padding-left: 1.5rem;
  color: #ffffff;
  line-height: 1.65;

  &::before {
    content: '✓';
    position: absolute;
    left: 0;
    color: #38ef7d;
    font-weight: bold;
  }
`;

const Quote = styled.blockquote`
  margin: 1.5rem 0 0;
  padding: 1rem 1.2rem;
  border-left: 4px solid #667eea;
  border-radius: 0 16px 16px 0;
  background: white;
  color: #667eea;
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.6;
  font-style: italic;
`;

const AwardGrid = styled.div`
  display: grid;
  gap: 0.75rem;
  margin-top: 1rem;
`;

const AwardItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: linear-gradient(135deg, #ffd89b, #c7e9fb);
  border-radius: 12px;
  color: #2d3748;
  font-weight: 500;
`;

const AwardIcon = styled.span`
  font-size: 1.2rem;
`;

const MembershipGrid = styled.div`
  display: grid;
  gap: 0.75rem;
  margin-top: 1rem;
`;

const MembershipItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem;
  background: #f7fafc;
  border-radius: 10px;
  transition: all 0.3s ease;
  
  &:hover {
    background: linear-gradient(135deg, #667eea10, #764ba210);
    transform: translateX(5px);
  }
`;

const MembershipIcon = styled.span`
  font-size: 1.1rem;
`;

const CheckList = styled.div`
  display: grid;
  gap: 1rem;
  margin-top: 1rem;
`;

const CheckItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.5rem;
  background: linear-gradient(135deg, #fef3c7, #fde68a);
  border-radius: 12px;
  color: #2d3748;
`;

const CheckIcon = styled.span`
  font-size: 1.2rem;
  color: #38a169;
  font-weight: bold;
`;

const LocationCard = styled(SectionCard)`
  background: linear-gradient(135deg, #fef3c7, #fde68a);
`;

const LocationItem = styled.div`
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: white;
  border-radius: 16px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const LocationName = styled.h4`
  margin: 0 0 0.5rem;
  color: #2d3748;
  font-size: 1.1rem;
  font-weight: 700;
`;

const Address = styled.p`
  margin: 0.5rem 0;
  color: #4a5568;
  line-height: 1.6;
  font-size: 0.9rem;
`;

const PhoneLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin: 0.5rem 0;
`;

const PhoneLinkSmall = styled.a`
  color: #667eea;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

const MapButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.75rem;
  padding: 0.6rem 1rem;
  background: linear-gradient(135deg, #34a853, #1e8e3e);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(52, 168, 83, 0.3);
  }
`;

const Divider = styled.hr`
  margin: 1rem 0;
  border: none;
  height: 2px;
  background: linear-gradient(90deg, #667eea, #764ba2);
`;

const ResidenceInfo = styled.p`
  margin: 1rem 0 0;
  padding-top: 1rem;
  border-top: 2px solid #667eea;
  color: #2d3748;
  font-size: 0.95rem;
  font-weight: 500;
`;

const EmergencyBadge = styled.div`
  margin-top: 1rem;
  padding: 0.75rem;
  background: linear-gradient(135deg, #ff6b6b, #c92a2a);
  color: white;
  text-align: center;
  border-radius: 12px;
  font-weight: 700;
  font-size: 0.85rem;
  animation: blink 1s infinite;
  
  @keyframes blink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.7; }
  }
`;

const AppointmentButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 1rem;
  width: 100%;
  min-height: 48px;
  padding: 0.85rem 1.5rem;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  text-decoration: none;
  font-weight: 700;
  transition: all 0.3s ease;
  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.3);
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 15px 35px rgba(102, 126, 234, 0.4);
  }
`;

const CommunityBadge = styled.div`
  margin-top: 1rem;
  padding: 0.75rem;
  background: linear-gradient(135deg, #4facfe, #00f2fe);
  color: white;
  text-align: center;
  border-radius: 12px;
  font-weight: 700;
  font-size: 0.9rem;
`;

const FormCard = styled(SectionCard)`
  overflow: hidden;
`;

const FormWrapper = styled.div`
  margin-top: 0rem;
  width: 100%;

  @media (max-width: 768px) {
    overflow-x: clip;
  }
`;